mutation UpdateOrganizationUserRoles($id: ID!, $roles: [OrganizationRole!]!) {
  updateOrganizationUserRoles(id: $id, roles: $roles) {
    id
    roles
    disabled
  }
}
